import React from 'react';
import { Button } from 'antd';
import { useGetPOAsQuery, useCreatePOAMutation } from '../../store/api/poaApi';
import { useNavigate } from 'react-router-dom';
import { DataTable } from '../../ui';

const POAPage: React.FC = () => {
  const { data = [], isLoading } = useGetPOAsQuery();
  const [createPOA, { isLoading: isCreating }] = useCreatePOAMutation();
  const navigate = useNavigate();

  const handleCreate = async () => {
    const poa = await createPOA({ status: 'draft' } as any).unwrap();
    navigate(`/poa/${poa.id}`);
  };

  return (
    <div style={{ padding: 24 }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 16 }}>
        <h2>Доверенности</h2>
        <Button type="primary" onClick={handleCreate} loading={isCreating}>Создать доверенность</Button>
      </div>
      <DataTable
        rowKey="id"
        loading={isLoading}
        dataSource={data}
        columns={[
          { title: '№', dataIndex: 'number' },
          { title: 'Дата выдачи', dataIndex: 'issueDate', render: (v) => v ? new Date(v).toLocaleDateString('ru-RU') : '' },
          { title: 'Организация', dataIndex: 'organizationName' },
          { title: 'Поставщик', dataIndex: 'supplierName' },
          { title: 'Сотрудник', dataIndex: 'employeeFullName' },
        ]}
        onRow={(record) => ({ onClick: () => navigate(`/poa/${record.id}`) })}
      />
    </div>
  );
};

export default POAPage;





